module.exports = __webpack_public_path__ + "static/media/tim.fa934b2c.png";